import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedCopyContent = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_22_260)">
          <rect
            x="5.9681"
            y="6.83529"
            width="13.7683"
            height="17.7021"
            rx="1.09272"
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect x="7.27947" y="17.9794" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
          <rect x="7.27947" y="19.9021" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
          <rect x="7.27947" y="21.8248" width="7.88808" height="0.898497" rx="0.449248" fill="#58AFFE" />
          <rect x="7.27947" y="16.0567" width="7.88808" height="0.898497" rx="0.449248" fill="#58AFFE" />
          <g clipPath="url(#clip0_22_260)">
            <path d="M18.5523 8.00013V14.6001H7.15231L18.5523 8.00013Z" fill="url(#paint0_linear_22_260)" />
            <path d="M7.15231 14.6001V8.00013H18.5523L7.15231 14.6001Z" fill="url(#paint1_linear_22_260)" />
          </g>
        </g>
        <g filter="url(#filter1_bdi_22_260)">
          <rect
            x="10.2636"
            y="3.46263"
            width="13.7683"
            height="17.7021"
            rx="1.09272"
            fill="white"
            fillOpacity="0.67"
            shapeRendering="crispEdges"
          />
          <rect x="11.5749" y="14.6065" width="11.1458" height="0.898496" rx="0.449248" fill="#58AFFE" />
          <rect x="11.5749" y="16.5292" width="11.1458" height="0.898497" rx="0.449248" fill="#58AFFE" />
          <rect x="11.5749" y="18.4519" width="7.88808" height="0.898497" rx="0.449248" fill="#58AFFE" />
          <rect x="11.5749" y="12.6837" width="7.88808" height="0.898496" rx="0.449248" fill="#58AFFE" />
          <g clipPath="url(#clip1_22_260)">
            <path d="M22.8 5.00013V11.6001H11.4L22.8 5.00013Z" fill="url(#paint2_linear_22_260)" />
            <path d="M11.4 11.6001V5.00013H22.8L11.4 11.6001Z" fill="url(#paint3_linear_22_260)" />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_22_260"
            x="0.458105"
            y="1.32529"
            width="24.7883"
            height="28.7221"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2.755" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_22_260" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_22_260" result="shape" />
          </filter>
          <filter
            id="filter1_bdi_22_260"
            x="5.89273"
            y="-0.908251"
            width="22.51"
            height="26.4438"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.18544" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_22_260" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.52435" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_22_260" result="effect2_dropShadow_22_260" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_22_260" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.218544" dy="0.218544" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
            <feBlend mode="normal" in2="shape" result="effect3_innerShadow_22_260" />
          </filter>
          <linearGradient
            id="paint0_linear_22_260"
            x1="13.1373"
            y1="10.4901"
            x2="14.062"
            y2="15.1366"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF6D00" />
            <stop offset="1" stopColor="#F8EF6F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_22_260"
            x1="7.15231"
            y1="9.81513"
            x2="12.408"
            y2="12.7532"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#47FF65" />
            <stop offset="1" stopColor="#2C99FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_22_260"
            x1="17.385"
            y1="7.49013"
            x2="18.3097"
            y2="12.1366"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF6D00" />
            <stop offset="1" stopColor="#F8EF6F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_22_260"
            x1="11.4"
            y1="6.81513"
            x2="16.6557"
            y2="9.75323"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#47FF65" />
            <stop offset="1" stopColor="#2C99FF" />
          </linearGradient>
          <clipPath id="clip0_22_260">
            <rect x="7.15231" y="8.00013" width="11.4" height="6.6" rx="1" fill="white" />
          </clipPath>
          <clipPath id="clip1_22_260">
            <rect x="11.4" y="5.00013" width="11.4" height="6.6" rx="1" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedCopyContent
